import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { useEffect, useId, useState } from 'react';
import { useAppSelector } from '../../../reducers';
import { productSelector, skuSelector } from '../../../selectors/ProductsSelectors';
import { trackModalInteraction } from '../../../utils/tracking/trackingEventUtils';
import AsyncContactsPriceBreakdownModal from '../../common/pricing/AsyncContactsPriceBreakdownModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IncludedContacts = ({
  quantityPackSkuId,
  trackingSource,
  queryParamTerm
}) => {
  const [priceBreakdownVisible, setPriceBreakdownVisible] = useState(false);
  const quantityPack = useAppSelector(state => skuSelector(state, {
    skuId: quantityPackSkuId
  }));
  const {
    includedWithProductVersion,
    productId
  } = quantityPack;
  const {
    productLine,
    productLevel
  } = useAppSelector(state => productSelector(state, {
    productId
  }));
  useEffect(() => {
    if (priceBreakdownVisible) {
      trackModalInteraction({
        action: 'click to open',
        name: 'contact-picker-more-details-modal',
        trackingSource,
        productLine,
        productLevel
      });
    }
  }, [priceBreakdownVisible, productLevel, productLine, trackingSource]);
  const marketingContactsTitleId = useId();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priceBreakdownVisible && /*#__PURE__*/_jsx(AsyncContactsPriceBreakdownModal, {
      quantityPackSkuId: quantityPackSkuId,
      handleModalClose: () => setPriceBreakdownVisible(false),
      queryParamTerm: queryParamTerm
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "start",
        gap: "200",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          id: marketingContactsTitleId,
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "pricingPage.contactsPicker.marketingContacts.title_jsx",
            elements: {
              IncludedAdditionalUnits: () => /*#__PURE__*/_jsx(FormattedNumber, {
                value: includedWithProductVersion
              }),
              Link: ({
                children
              }) => /*#__PURE__*/_jsx(View, {
                marginBlockStart: "200",
                display: "inline-block",
                as: "span",
                children: /*#__PURE__*/_jsx(Link, {
                  onClick: () => setPriceBreakdownVisible(true),
                  onMouseEnter: () => void AsyncContactsPriceBreakdownModal.preload(),
                  "data-selenium-id": "marketing-contacts-modal-open-button",
                  children: children
                })
              })
            }
          })
        })
      })
    })]
  });
};
export default IncludedContacts;